import instance from ".";
import { API_ENDPOINTS } from "../utils/constants";

export const sendSMSForSignup = (phoneNumber) => {
  return instance.post(API_ENDPOINTS.message.sendSMSForSignup, { phoneNumber });
};

export const sendSMSForFindAccount = (phoneNumber) => {
  return instance.post(API_ENDPOINTS.message.sendSMSForFindAccount, {
    phoneNumber,
  });
};

export const sendSMSToUser = (userId, phoneNumber) => {
  return instance.post(API_ENDPOINTS.message.sendSMSToUser, {
    userId,
    phoneNumber,
  });
};

export const verifySMS = (phoneNumber, code) => {
  return instance.post(API_ENDPOINTS.message.verifySMS, { phoneNumber, code });
};
